//Permanent
const brand: string = "Correo";
const twitterAccount: string = "diariocorreo";    
const urlBrand: string = "https://diariocorreo.pe/";
const brandSlug: string = '';
const urlPortadaEspeciales: string = "https://especiales.diariocorreo.pe/especiales-correo-xvisual/index.html";
const domainMarca: string = "https://especiales.diariocorreo.pe/";
const domainAssets: string = 'https://especiales.diariocorreo.pe/';
const slugCommonAssets: string = 'elementos-comunes/';
const urlCommonAssets: string = `${domainAssets}${slugCommonAssets}`;

//Variables
const title: string = "Compara los perfiles\nde los candidatos al Gobierno\nRegional de Piura";
const titleEspecial: string = `Conoce a los candidatos para el Gobierno Regional de Piura | Elecciones 2022 | ${brand}`;
const slugEspecial: string = 'piura-conoce-y-compara-los-perfiles-candidatos-gobierno-regional-peru-elecciones-22-multimedia-nndd';
const urlEspecial: string = `${domainMarca}${slugEspecial}/index.html`;
const urlAssets: string = `${domainAssets}${slugEspecial}/`; 
const urlXlsx: string = `${urlAssets}xlsx/ComparativadecandidatosPiura.xlsx`;
const queryStrStart: string = '?';
const queryStr1StParty: string = 'idPartido1';
const queryStr2NdParty: string = 'idPartido2';
const resumeItemsStart: number = 2;

//ads
const lateralDerecho = {
    id: 'div-gpt-ad-1583794008981-0',
    path: '/28253241/diariocorreo/web/post/default/lateralr',
    size: [[160, 600], 'fluid', [120, 600]]    
};
const lateralIzquierdo = {
    id: 'div-gpt-ad-1583794031430-0',
    path: '/28253241/diariocorreo/web/post/default/laterall',
    size: [[120, 600], 'fluid', [160, 600]]    
};
const caja3 = {
    id: 'div-gpt-ad-1583794076864-0',
    path: '/28253241/diariocorreo/web/post/default/caja3',
    size: ['fluid', [300, 100], [300, 50], [300, 250], [320, 100], [320, 50]]    
};
const zocalo = {
    id: 'div-gpt-ad-1582159417206-0',
    path: '/28253241/diariocorreo/web/post/default/zocalo',
    size: [[728, 90], [320, 50]]    
};

export { 
    brand, 
    brandSlug,
    queryStr1StParty,
    queryStr2NdParty,
    queryStrStart,
    resumeItemsStart,
    title,
    titleEspecial, 
    twitterAccount, 
    urlAssets, 
    urlBrand, 
    urlCommonAssets, 
    urlEspecial,
    urlPortadaEspeciales, 
    urlXlsx,
    caja3,
    lateralDerecho,
    lateralIzquierdo,
    zocalo
};